const GOMS_FULFILLMENT_CONSTANTS = {
  GETTING_GOMS_CONFIG: 'GETTING_GOMS_CONFIG',
  GET_GOMS_CONFIG_SUCCESS: 'GET_GOMS_CONFIG_SUCCESS',
  GET_GOMS_CONFIG_FAILURE: 'GET_GOMS_CONFIG_FAILURE',

  GETTING_GOMS_ON_HOLD_FULFILLMENTS: 'GETTING_GOMS_ON_HOLD_FULFILLMENTS',
  GET_GOMS_ON_HOLD_FULFILLMENTS_SUCCESS: 'GET_GOMS_ON_HOLD_FULFILLMENTS_SUCCESS',
  GET_GOMS_ON_HOLD_FULFILLMENTS_FAILURE: 'GET_GOMS_ON_HOLD_FULFILLMENTS_FAILURE',

  GETTING_GOMS_FULFILLMENT_BY_ID: 'GETTING_GOMS_FULFILLMENT_BY_ID',
  GET_GOMS_FULFILLMENT_BY_ID_SUCCESS: 'GET_GOMS_FULFILLMENT_BY_ID_SUCCESS',
  GET_GOMS_FULFILLMENT_BY_ID_FAILURE: 'GET_GOMS_FULFILLMENT_BY_ID_FAILURE',

  FORCE_INITIATING_GOMS_FULFILLMENT: 'FORCE_INITIATING_GOMS_FULFILLMENT',
  FORCE_INITIATE_GOMS_FULFILLMENT_SUCCESS: 'FORCE_INITIATE_GOMS_FULFILLMENT_SUCCESS',
  FORCE_INITIATE_GOMS_FULFILLMENT_FAILURE: 'FORCE_INITIATE_GOMS_FULFILLMENT_FAILURE',

  SET_GOMS_FULFILLMENTS_TO_INITIAL_STATE: 'SET_GOMS_FULFILLMENTS_TO_INITIAL_STATE'
};

export default GOMS_FULFILLMENT_CONSTANTS;